import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import Carousel from 'nuka-carousel';

const Container = styled.div`
  .slider-container {
    position: relative;
    display: block;
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }

  .slider-list {
    position: relative;
    display: flex;
    overflow: hidden;
    gap: 16px;
  }

  .slider-list:focus {
    outline: 0;
  }

  .slider-list.dragging {
    cursor: pointer;
    cursor: hand;
  }

  .slider-container .slider-list,
  .slider-container .slick-track {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  .slick-track {
    position: relative;
    top: 0;
    left: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .slick-track:after,
  .slick-track:before {
    display: table;
    content: '';
  }

  .slick-track:after {
    clear: both;
  }

  .slick-loading .slick-track {
    visibility: hidden;
  }

  .slick-slide {
    display: none;
    float: left;
    height: 100%;
    min-height: 1px;
  }

  [dir='rtl'] .slick-slide {
    float: right;
  }

  .slick-slide img {
    display: block;
  }

  .slick-slide.slick-loading img {
    display: none;
  }

  .slick-slide.dragging img {
    pointer-events: none;
  }

  .slick-initialized .slick-slide {
    display: block;
  }

  .slick-loading .slick-slide {
    visibility: hidden;
  }

  .slick-vertical .slick-slide {
    display: block;
    height: auto;
    border: 1px solid transparent;
  }

  .slick-arrow.slick-hidden {
    display: none;
  }

  @media (min-width: 1024px) {
    .slider-list {
      gap: 24px;
    }
  }
`;

export default function Slider(props) {
  const [isChildFound, setIsChildFound] = useState(false);
  const sliderRef = useRef<HTMLDivElement>(null);

  const checkChildExistence = () => {
    if (sliderRef && sliderRef.current && !isChildFound) {
      const slickInitializedChild = sliderRef.current.querySelector('.slider-frame');
      const staticInitializedChild = sliderRef.current.querySelector('.regular');

      const slides = sliderRef.current.querySelectorAll('.slide');
      slides.forEach(slide => {
        slide.classList.add('slide-visible');
        slide.removeAttribute('inert');
      });

      if (slickInitializedChild || staticInitializedChild) {
        setIsChildFound(true);
      }
    }
  };

  const intervalId = setInterval(() => {
    if (isChildFound) {
      clearInterval(intervalId);
    }
    checkChildExistence();
  }, 1000);

  return (
    <Container
      ref={sliderRef}
      className={isChildFound ? 'is-initialized' : ''}
      style={isChildFound ? { height: 'auto' } : { height: '310px' }}
    >
      <Carousel {...props} />
    </Container>
  );
}
